export default __webpack_public_path__ + "static/media/Ack.01061b88.svg";